/* Vissla custom: BEGIN vissla-custom.js
   Newsletter popup behavior ported from Impulse 7.3.3 (Vissla edit in the old theme.js):
   - The popup must NEVER auto-open.
   - It opens only when #inline-popup (footer-new "Sign Up For Our Newsletter") is clicked,
     by dispatching 'reminder:openNewsletter', which theme.js's NewsletterPopup listens for.
   Auto-open suppression (stock 9.1.0 has no "disable auto-show" setting):
   1. sessionStorage 'newsletterAppeared' = 'true' diverts the delayed auto-open to the
      reminder path on this page load (the reminder block is disabled, so nothing shows).
   2. The section's own 'newsletter-<sectionId>' cookie suppresses auto-open on later loads.
   Also popup_seconds is set to 60 in sections/popup-group.json as defense in depth.
*/
(function () {
  try {
    sessionStorage.setItem('newsletterAppeared', 'true');
  } catch (e) {
    /* no-op: sessionStorage unavailable */
  }

  var popup = document.querySelector('[data-section-type="newsletter-popup"]');
  if (popup) {
    var sectionId = popup.getAttribute('data-section-id');
    if (sectionId && document.cookie.indexOf('newsletter-' + sectionId + '=') === -1) {
      document.cookie = 'newsletter-' + sectionId + '=opened; path=/; max-age=31536000';
    }
  }

  function bindTrigger() {
    var trigger = document.getElementById('inline-popup');
    if (!trigger || trigger.dataset.visslaPopupBound === 'true') {
      return;
    }
    trigger.dataset.visslaPopupBound = 'true';
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('reminder:openNewsletter', { bubbles: true }));
    });
  }

  if (document.readyState !== 'loading') {
    bindTrigger();
  } else {
    document.addEventListener('DOMContentLoaded', bindTrigger);
  }
})();
/* Vissla custom: END vissla-custom.js */

/* Vissla custom: BEGIN product features modal */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.features-box') || !window.theme || !theme.Modals) return;
  var featureModal = new theme.Modals('FeaturePopup', 'feature-popup-modal');
  document.querySelectorAll('.features-box a').forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelectorAll('.feature-content').forEach(function (el) { el.style.display = 'none'; });
      var t = document.querySelector('.feature-content[data-name="' + item.getAttribute('data-name') + '"]');
      if (t) t.style.display = 'block';
      featureModal.open();
    });
  });
});
/* Vissla custom: END product features modal */

/* Vissla AU custom.js carried (from AU live assets/custom.js, 2026-06-06): social sharing toggle. jQuery available via vissla jquery-libs fence in theme.liquid. */
$(document).ready(function () {

   // Sharing tools
    $('body').on('click', '.sharing [type=button].share', function(e) {
      e.preventDefault();
      $('.social-sharing').toggle();
    });

});
/* Vissla AU custom.js carried: END */

/* Vissla custom: BEGIN help-accordion (FAQ toggle; AU page.help uses h3 questions. Adds click and keyboard toggle of .open on the li; the open-state CSS in templates/page.help.liquid reveals the answer) */
(function () {
  function initAccordion() {
    var headers = document.querySelectorAll('.accordion li > h3, .accordion li > h4');
    if (!headers.length) return;
    headers.forEach(function (h) {
      h.style.cursor = 'pointer';
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
      function toggle() {
        var li = h.parentElement;
        var open = li.classList.toggle('open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }
  if (document.readyState !== 'loading') initAccordion();
  else document.addEventListener('DOMContentLoaded', initAccordion);
})();
/* Vissla custom: END help-accordion */
